{
	"analyzingBackground": "We're analyzing your photos in the background. You can start editing now—AI features will be available shortly.",
	"ariaClusteringProgress": "clustering progress",
	"ariaSkipPhotoClustering": "Skip Photo Clustering",
	"continueInBackground": "Continue in background",
	"preparingPhotos": "Preparing photos for faster AI edits...",
	"progress": "Progress",
	"progressText": "{{clusteredCount}} / {{totalCount}} photos ({{progressPercent}}%)"
}
